import { mdiCreditCardOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Typography } from '@mui/material';

import { useUserContext } from '../../contexts/User.context';
import { Carteira as CarteiraModel } from '../../models/Carteira.model';
import { Colors } from '../../shared/colors';

import ErrorCarteira from './Carteira/ErrorCarteira';
import Currency from './Currency';

export interface CardCarteiraProps {
  carteira: CarteiraModel;
}

export default function CardCarteira({ carteira }: CardCarteiraProps) {
  const { user } = useUserContext();
  const nomeEmpresa = user && 'cnpj' in user ? user.nomeFantasia : '';

  return (
    <Box
      sx={{
        borderRadius: '0.5rem',
        overflow: 'hidden',
        border: carteira.saldoBloqueado ? `2px solid ${Colors.error.red}` : 'none',
        boxShadow: '0 8px 20px rgba(9, 48, 119, 0.16)'
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        minHeight={104}
        px={2.5}
        py={2}
        sx={{
          background:
            'linear-gradient(90deg, #216BC9 0%, #124A9C 28%, #082C70 50%, #124A9C 72%, #216BC9 100%)'
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={48}
          height={48}
          borderRadius="50%"
          flexShrink={0}
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.16)',
            border: '1px solid rgba(255, 255, 255, 0.32)'
          }}
        >
          <Icon path={mdiCreditCardOutline} size={1.35} color={Colors.white} />
        </Box>
        <Box
          flex={1}
          minWidth={0}
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          gap={{ xs: 0.5, md: 2 }}
        >
          <Box flexShrink={0}>
            <Typography color={Colors.white} fontSize={14} fontWeight={500} lineHeight={1.2}>
              Saldo Disponível
            </Typography>
            <Typography color={Colors.white} fontSize={26} fontWeight={700} lineHeight={1.25}>
              <Currency value={carteira.saldo} />
            </Typography>
          </Box>
          {nomeEmpresa && (
            <Typography
              color={Colors.white}
              fontSize={13}
              fontWeight={600}
              title={nomeEmpresa}
              textAlign={{ xs: 'left', md: 'right' }}
              sx={{
                maxWidth: { xs: '100%', md: '45%' },
                opacity: 0.9,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {nomeEmpresa}
            </Typography>
          )}
        </Box>
      </Box>
      {carteira.saldoBloqueado && (
        <ErrorCarteira message="Conta Bloqueada! Entre em contato com a Administração." />
      )}
    </Box>
  );
}
